import './App.css'
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom'
import React, { Suspense, useEffect } from 'react';
import { logger } from './utils/logger';
import { ScrollToTop } from './utils/ScrollToTop'
import RequireAuth from './RequireAuth';
import OtpVerification from './components/OTP/OtpVerification';
import ProfileCompletion from './components/ProfileCompletion/ProfileCompletion';

const WebShop = React.lazy(() => import('./pages/webShop'));
//const RequireAuth = React.lazy(() => import('./RequireAuth'));
 const Start = React.lazy(() => import('./components/home/Start'));
 const ForgotPassword = React.lazy(() => import('./components/ForgetPassword/ForgetPassword'));
 const ResetPassword = React.lazy(() => import('./components/ResetPassword/ResetPassword'));
 const UpdatePass = React.lazy(() => import('./components/UpdatePass/UpdatePass'));
const Success = React.lazy(() => import('./pages/Success'));
const Membership = React.lazy(() => import('./pages/Membership'));
const UserCards = React.lazy(() => import('./pages/UserCards'));
const EventDetails = React.lazy(() => import('./pages/EventDetails'));
 const Login = React.lazy(() => import('./components/Login/Login'));
 const EcommerceProductDetails = React.lazy(() => import('./components/EcommerceProductDetails'));
 const SignUp = React.lazy(() => import('./components/SignUp/SignUp'));
 const EcommerceCheckout = React.lazy(() => import('./pages/EcommerceCheckout'));
 const Partners = React.lazy(() => import('./pages/Partners'));
 const UserAccount = React.lazy(() => import('./pages/UserAccount'));
 const OrderHistory = React.lazy(() => import('./pages/OrderHistory'));
 const PartnersMembership = React.lazy(() => import('./pages/PartnersMembership'));
 const PartnersCheckout = React.lazy(() => import('./pages/PartnersCheckout'));
 const PartnersSuccess = React.lazy(() => import('./pages/PartnersSuccess'));
 const PublicJoinMembership = React.lazy(() => import('./pages/PublicJoinMembership'));
 const PublicClaimMembership = React.lazy(() => import('./pages/PublicClaimMembership'));


function App() {
  useEffect(() => {
    logger.log('App mounted');
  }, []);
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
         
          {/* Root path shows StartPage (public landing). If you intended pages/index.jsx for '/', swap to element={<Home />} */}
          {/* <Route path="/" element={<StartPage />} /> */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/verify-otp" element={<OtpVerification />} />
          <Route path="/profile/complete" element={<ProfileCompletion />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/update-password" element={<UpdatePass />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/partners/medlem" element={<PartnersMembership />} />

          {/* <Route path="/about_us" element={<AboutUs />} />
          <Route path="/integritets_policy" element={<IntegritetsPolicy />} />
          <Route path="/cookie_policy" element={<CookiePolicy />} />
          <Route path="/nyheter" element={<BlogPosts />} /> */}
          <Route path="/arrangemang" element={<UserCards />} />
          {/* Public membership join page (no auth) */}
          <Route path="/bli-medlem" element={<PublicJoinMembership />} />
          {/* Public membership claim page (no auth) */}
          <Route path="/medlem/claim/:token" element={<PublicClaimMembership />} />

          {/* Event detail route now uses a slug generated from event.eventTitle */}
          <Route path="/arrangemang/:slug" element={<EventDetails />} />

          {/* Legacy redirects from /event and /event/:slug to /arrangemang */}
          <Route path="/event" element={<Navigate to="/arrangemang" replace />} />
          <Route path="/event/:slug" element={<EventLegacyRedirect />} />
          <Route path="/produkt" element={<WebShop />} />
          <Route path="/produkt/:slug" element={<EcommerceProductDetails />} />
          <Route path="/webshop" element={<Navigate to="/produkt" replace />} />
          <Route path="/webshop/:slug" element={<WebshopLegacyRedirect />} />

          <Route element={<RequireAuth />}>
            <Route path="/start" element={<Start />} />
            <Route path="/edit-profile" element={<UserAccount />} />
            <Route path="/orders-history" element={<OrderHistory />} />
            <Route path="/produkt">
              <Route path="cart" element={<EcommerceCheckout />} />
              <Route path="success" element={<Success />} />
              <Route path="membership" element={<Membership />} />
            </Route>
            <Route path="/partners">
              <Route
                path="/partners/payment/:className"
                element={<PartnersCheckout />}
              />
              <Route path="/partners/success" element={<PartnersSuccess />} />
            </Route>
          </Route>
          <Route path="*" element={React.createElement(React.lazy(() => import('./pages/NotFound')))} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
export default App

// Redirect component to handle legacy /event/:slug URLs, optionally stripping a trailing 24-char id
function EventLegacyRedirect() {
  const { slug } = useParams();
  const parts = (slug || '').split('-');
  const last = parts[parts.length - 1] || '';
  const isMongoId = /^[0-9a-fA-F]{24}$/.test(last);
  const cleaned = (isMongoId ? parts.slice(0, -1) : parts).join('-').toLowerCase();
  const to = `/arrangemang/${cleaned}`;
  return <Navigate to={to} replace />;
}

function WebshopLegacyRedirect() {
  const { slug } = useParams();
  const to = slug ? `/produkt/${slug}` : '/produkt';
  return <Navigate to={to} replace />;
}

